module.exports = __webpack_public_path__ + "images/saaremaa/ms-icon-144x144.png";